const finite = (value) => Number.isFinite(Number(value));

// Wspólna paleta dla wizualizacji okręgów: okrąg jest fioletowy,
// a punkty konstrukcyjne oraz promienie i średnice — pomarańczowe.
export const CIRCLE_GRAPH_COLORS = Object.freeze({
  circle: "#8b3dff",
  point: "#ff9800",
  segment: "#ff9800",
});

// Rozmiar kratki nie zależy od zasięgu układu. Sam wykres może być większy,
// ale każda jednostka na osi ma tę samą czytelną skalę.
// Taki sam, bazowy rozmiar kratki jak w standardowych wykresach funkcji
// i wizualizacjach teorii. Zmieniamy wielkość kadru, nie oczek siatki.
const GRID_CELL_PX = 30;
const GRAPH_MARGINS_PX = 60;

// Utrzymuje kwadratową siatkę, pełny rysunek i obie osie w kadrze.
export function getCircleGraphRanges({ circles = [], points = [], minSpan = 8, padding = 1 } = {}) {
  const xValues = [0];
  const yValues = [0];

  circles.forEach(({ center, radius }) => {
    if (!center || !finite(radius)) return;
    const r = Math.abs(Number(radius));
    if (finite(center.x)) xValues.push(Number(center.x) - r, Number(center.x) + r);
    if (finite(center.y)) yValues.push(Number(center.y) - r, Number(center.y) + r);
  });

  points.forEach((point) => {
    if (!point) return;
    if (finite(point.x)) xValues.push(Number(point.x));
    if (finite(point.y)) yValues.push(Number(point.y));
  });

  const minX = Math.floor(Math.min(...xValues) - padding);
  const maxX = Math.ceil(Math.max(...xValues) + padding);
  const minY = Math.floor(Math.min(...yValues) - padding);
  const maxY = Math.ceil(Math.max(...yValues) + padding);
  const span = Math.max(minSpan, maxX - minX, maxY - minY);
  const evenSpan = Math.ceil(span / 2) * 2;

  const makeRange = (min, max) => {
    const extra = evenSpan - (max - min);
    const before = Math.floor(extra / 2);
    return [min - before, min - before + evenSpan];
  };

  return {
    xRange: makeRange(minX, maxX),
    yRange: makeRange(minY, maxY),
    graphSize: Math.max(420, evenSpan * GRID_CELL_PX + GRAPH_MARGINS_PX),
  };
}
